import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Input } from "../components/tag/Input";
import { Button } from "../components/tag/Button";
import IMG from "../assets/img/Img";
import { showToast } from "../components/utils/Toastify";

import { useApi } from "../components/hooks/useApi";
import { ApiService } from "../components/service/ApiService";
import { AuthService } from "../components/service/AuthService";
import { useMovePage } from "../components/hooks/usePageMove";

export const LoginPage = () => {
    const [comCd, setComCd] = useState("");
    const [memId, setMemId] = useState("");
    const [password, setPassword] = useState("");

    const { execute } = useApi();
    const { go } = useMovePage();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // Angular에서 토큰과 함께 리다이렉트된 경우 자동 로그인
        const token = searchParams.get("token");
        const paramComCd = searchParams.get("comCd");
        const paramMemId = searchParams.get("memId");

        if (token && paramComCd && paramMemId) {
            AuthService.setToken(token);
            AuthService.setComCd(paramComCd);
            AuthService.setMemId(paramMemId);
            go("/manage/feeder");
            return;
        }

        if(AuthService.isLoggedIn()){
            go("/manage/feeder");
        }
    }, [go, searchParams]);

    const onSubmit = async () => {
        const { success, data, error } = await execute(() =>
            ApiService.post("auth/login", { comCd, memId, password })
        );

        if (success) {
            AuthService.setToken(data.access_token);
            AuthService.setMemId(data.memId);
            AuthService.setComCd(data.comCd);

            go("/manage/feeder");
        }

        if (error) {
            let errorMessage = '';
            const errMsg = error.error?.message || error.message || '';
            console.log(errMsg);
            switch (errMsg) {
                case 'noTable':
                    errorMessage = '회사 코드가 없습니다. \n회사 코드를 확인해주세요.';
                    break;
                case 'noUser':
                    errorMessage = '가입된 회원이 없습니다.';
                    break;
                case 'pwErr':
                    errorMessage = '아이디나 비밀번호가 다릅니다. \n아이디,비밀번호를 확인해주세요.';
                    break;
                default:
                    errorMessage = `알수 없는 에러 (코드: ${error.status || 'N/A'}). \n관리자에게 문의해 주세요.`;
                    break;
            }
            showToast.error(errorMessage);
        }
    }

    return (
        <div className="min-h-screen bg-[#e4e5e6] p-4 flex justify-center items-center">
            <div className="flex flex-row max-w-[730px] w-full min-h-[373px] bg-white border border-[#c8ced3] rounded-2xl overflow-hidden">
                <div className="flex-1 border-r border-[#c8ced3] p-[44px]">
                    <h1 className="leading-[1.2] font-bold text-[2.1875rem] mb-2">로그인</h1>
                    <p className="text-[0.875rem] text-[#73818f] mb-4">스마트 양식장 관리시스템</p>
                    <div className="flex flex-col gap-4 mb-6">
                        <div className="flex h-[35px] rounded-[10px] border border-[#e4e7ea]">
                            <span style={{ backgroundImage: `url(${IMG.HOME_ICON})` }} className="w-[40px] rounded-l-[10px] h-full flex justify-center items-center border-r border-[#e4e7ea] bg-[#f0f3f5] bg-no-repeat bg-center bg-[length:45%]"></span>
                            <Input type="text" placeholder="회사코드" className="flex-1 rounded-r-[10px]" value={comCd} onChange={(e) => setComCd(e.target.value)} />
                        </div>
                        <div className="flex h-[35px] rounded-[10px] border border-[#e4e7ea]">
                            <span style={{ backgroundImage: `url(${IMG.USER_ICON})` }} className="w-[40px] rounded-l-[10px] h-full flex justify-center items-center border-r border-[#e4e7ea] bg-[#f0f3f5] bg-no-repeat bg-center bg-[length:45%]"></span>
                            <Input type="text" placeholder="아이디" className="flex-1 rounded-r-[10px]" value={memId} onChange={(e) => setMemId(e.target.value)} />
                        </div>
                        <div className="flex h-[35px] rounded-[10px] border border-[#e4e7ea]">
                            <span style={{ backgroundImage: `url(${IMG.LOCK_ICON})` }} className="w-[40px] rounded-l-[10px] h-full flex justify-center items-center border-r border-[#e4e7ea] bg-[#f0f3f5] bg-no-repeat bg-center bg-[length:45%]"></span>
                            <Input type="password" placeholder="패스워드" className="flex-1 rounded-r-[10px]" value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                    </div>
                    <div className="flex justify-between flex-wrap">
                        <Button type="button" className="p-1 w-[90px] btn btn-primary rounded-[10px]" onClick={onSubmit}>로그인</Button>
                        <Button type="button" className="p-0 btn btn-link">비밀번호를 잊으셨습니까?</Button>
                    </div>
                </div>
                <div
                    style={{ backgroundImage: `url(${IMG.GRAPHIC_BG})` }}
                    className="
                        w-[46%]
                        bg-no-repeat 
                        bg-top 
                        bg-center 
                        bg-[length:auto_105%]
                        hidden sm:block">
                </div>
            </div>
        </div>
    )
}